<template>
	<div class="trained-face-list-assignment">
		<div class="caption font-weight-medium mb-1">{{ titleText }}</div>

		<v-alert v-if="empty" dense outlined type="info" class="mb-2">
			{{ emptyText }}
		</v-alert>

		<v-select
			ref="listSelect"
			:value="value"
			:items="lists"
			:item-text="itemText"
			:item-value="itemValue"
			:menu-props="selectMenuProps"
			:loading="loading"
			:disabled="loading"
			multiple
			dense
			outlined
			chips
			:label="selectLabelText"
			:error-messages="error ? [error] : []"
			@input="$emit('input', $event)"
		>
			<template v-slot:append-item>
				<v-divider class="my-1"></v-divider>
				<div class="trained-face-list-assignment__selector-create px-3 py-2" role="group" :aria-label="createActionText">
					<v-btn
						v-if="!showCreateForm"
						text
						small
						block
						color="secondary"
						class="trained-face-list-assignment__create-action justify-start"
						:disabled="creating"
						@click.stop="openCreateForm"
					>
						{{ createActionText }}
					</v-btn>

					<div v-else class="trained-face-list-assignment__create-form">
						<v-text-field
							:value="newListName"
							dense
							outlined
							hide-details="auto"
							:label="createLabelText"
							:error-messages="createError ? [createError] : []"
							@input="$emit('update:new-list-name', $event)"
							@keydown.enter.stop.prevent="submitCreate"
						></v-text-field>
						<div class="d-flex align-center mt-2">
							<v-btn
								x-small
								color="secondary"
								class="trained-face-list-assignment__create-submit mr-2"
								:loading="creating"
								:disabled="creating || !newListName"
								@click.stop="submitCreate"
							>
								{{ createActionText }}
							</v-btn>
							<v-btn x-small text class="trained-face-list-assignment__create-cancel" :disabled="creating" @click.stop="closeCreateForm">
								{{ createCancelText }}
							</v-btn>
						</div>
					</div>
				</div>
				<v-divider class="my-1"></v-divider>
				<div class="trained-face-list-assignment__menu-footer px-3 py-2">
					<v-btn
						text
						small
						block
						color="primary"
						class="trained-face-list-assignment__menu-done"
						@click.stop="closeMenu"
					>
						{{ closeActionText }}
					</v-btn>
				</div>
			</template>
		</v-select>

		<v-alert v-if="pendingMessage" dense outlined type="warning" class="mt-2 trained-face-list-assignment__pending">
			{{ pendingMessage }}
			<v-btn x-small text color="warning" class="ml-2" @click="$emit('retry-pending')">
				{{ retryText }}
			</v-btn>
		</v-alert>
	</div>
</template>

<script>
	export default {
		name: 'TrainedFaceListAssignment',
		props: {
			value: { type: Array, default: () => [] },
			lists: { type: Array, default: () => [] },
			loading: { type: Boolean, default: false },
			creating: { type: Boolean, default: false },
			newListName: { type: String, default: '' },
			error: { type: String, default: '' },
			createError: { type: String, default: '' },
			pendingMessage: { type: String, default: '' },
			title: { type: String, default: 'Assign to face lists' },
			selectLabel: { type: String, default: 'Face lists' },
			emptyText: { type: String, default: 'No face lists yet. Create one here to continue.' },
			createLabel: { type: String, default: 'New list name' },
			createAction: { type: String, default: 'Create list' },
			createCancel: { type: String, default: 'Cancel' },
			closeAction: { type: String, default: 'Done' },
			retryText: { type: String, default: 'Retry assignment' },
		},
		data: () => ({
			showCreateForm: false,
		}),
		computed: {
			empty(){
				return !this.loading && !this.lists.length
			},
			titleText(){ return this.title },
			selectLabelText(){ return this.selectLabel },
			createLabelText(){ return this.createLabel },
			createActionText(){ return this.createAction },
			createCancelText(){ return this.createCancel },
			closeActionText(){ return this.closeAction },
			selectMenuProps(){
				return { closeOnContentClick: false }
			},
		},
		watch: {
			creating(isCreating, wasCreating){
				if (wasCreating && !isCreating && !this.createError) this.showCreateForm = false
			},
		},
		methods: {
			openCreateForm(){
				this.showCreateForm = true
			},
			closeCreateForm(){
				this.showCreateForm = false
				this.$emit('update:new-list-name', '')
			},
			submitCreate(){
				if (this.creating || !this.newListName) return
				this.$emit('create')
			},
			closeMenu(){
				if (this.$refs.listSelect) {
					this.$refs.listSelect.isMenuActive = false
					if (typeof this.$refs.listSelect.blur === 'function') this.$refs.listSelect.blur()
				}
			},
			itemText(item){
				return item && (item.name || item.title || item.label || item.id)
			},
			itemValue(item){
				return item && (item.id || item.uuid || item._id)
			},
		},
	}
</script>
